import { render, staticRenderFns } from "./InformativaRichiestaInformazioni.vue?vue&type=template&id=a88ab38c&"
import script from "./InformativaRichiestaInformazioni.vue?vue&type=script&lang=js&"
export * from "./InformativaRichiestaInformazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports